/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_BackInputs */

const en_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Back`)
};

const es_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver`)
};

const fr_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const de_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückgehen`)
};

const ja_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻る`)
};

const zh_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回上一页`)
};

const ar_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العودة للخلف`)
};

const id_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali`)
};

const it_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna Indietro`)
};

const ru_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернуться`)
};

const pt_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const ko_go_back = /** @type {(inputs: Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`돌아가기`)
};

/**
* | output |
* | --- |
* | "Go Back" |
*
* @param {Go_BackInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const go_back = /** @type {((inputs?: Go_BackInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_BackInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_go_back(inputs)
	if (locale === "es") return es_go_back(inputs)
	if (locale === "fr") return fr_go_back(inputs)
	if (locale === "de") return de_go_back(inputs)
	if (locale === "ja") return ja_go_back(inputs)
	if (locale === "zh") return zh_go_back(inputs)
	if (locale === "ar") return ar_go_back(inputs)
	if (locale === "id") return id_go_back(inputs)
	if (locale === "it") return it_go_back(inputs)
	if (locale === "ru") return ru_go_back(inputs)
	if (locale === "pt") return pt_go_back(inputs)
	return ko_go_back(inputs)
});